export const GET_SHOPON_WALL_REDUCER = "GET_SHOPON_WALL_REDUCER"
export const GET_SHOPON_PRODUCT_REDUCER = "GET_SHOPON_PRODUCT_REDUCER"
export const GET_SHOPON_PRODUCT_BYSLUG_REDUCER = "GET_SHOPON_PRODUCT_BYSLUG_REDUCER"
export const GET_SHOPON_POST_BYSLUG_REDUCER = "GET_SHOPON_POST_BYSLUG_REDUCER"
export const LOAD_MORE_POST_REDUCER ="LOAD_MORE_POST_REDUCER"
export const LOAD_MORE_PRODUCT_REDUCER ="LOAD_MORE_PRODUCT_REDUCER"
export const IS_LOADER_REDUCER ="IS_LOADER_REDUCER"
export const IS_PRODUCT_LOADER_REDUCER="IS_PRODUCT_LOADER_REDUCER"